import React, { useState, useRef } from 'react';

import EditableTag from '../shared/EditableTag';
import ItemsAppender from './ItemsAppender';
import SpinLoader from '../shared/SpinLoader';
import { deleteItem, focusRef } from '../shared/EventHelpers';

const EditItemList = ({
    iconName,
    value: items,
    setValue: setItems,
    onKeyDown,
    getSuggestions,
    isCreationPermitted,
    isInvalid,
    autoFocus,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef();


    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`input-wrapper ${isInvalid ? 'invalid' : ''}`} onClick={() => focusRef(inputRef)}>
                {items &&
                    items.map((item, index) => (
                        <div className='d-flex justify-content-between' key={item.id ? item.id : index}>
                            <EditableTag label={item.name} handleDelete={() => deleteItem(items, setItems, item)} />
                            {item.id === null ? <div className='new-badge' /> : null}
                        </div>
                    ))}
                <ItemsAppender
                    {...{ iconName, items, setItems, setIsLoading, onKeyDown, getSuggestions, isCreationPermitted, inputRef, autoFocus }}
                />
                <SpinLoader isLoading={isLoading} />
            </div>
        </div>
    );
};

export default EditItemList;
